var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    rate,
    rateAsJSON,
    index,
    loanAmount,
    minDraw,
    loanType
  } = options;

__p+='\n\n<!-- Rate Card -->\n<div class="hel-rate-card" data=\''+
((__t=( rateAsJSON ))==null?'':__t)+
'\'>\n   <div>\n      <div class="row gutter-sm">\n        <div class="col-xs-4 col-xxs-6">\n          ';
 if (rate.IsSponsored) {
__p+='\n            <div class="sponsored-label">FEATURED</div>\n          ';
 } 
__p+='\n          ';
 if (!rate.IsEditorial && rate.LogoPath) {
__p+='\n              <a href="'+
((__t=( rate.CpcUrl ))==null?'':__t)+
'" class="link-rate-detail link-logo hidden-xs" target=\'_blank\' rel=\'nofollow\'>\n               <img src="'+
((__t=( rate.LogoPath ))==null?'':__t)+
'" class=\'lender-logo margin-bottom-sm display-block\' data-omtag=\'rate_table:lender\'/>\n              </a>\n          ';
} else {
__p+='\n            <div class="lender margin-bottom">'+
((__t=( rate.Advertiser ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          ';
 if (rate.Nmls) {
__p+='\n            <div class="nmls-number">NMLS&nbsp;&num;&nbsp;'+
((__t=( rate.Nmls ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          ';
 if (rate.PhoneNo) {
__p+='\n            <a href="tel:'+
((__t=( rate.PhoneNo ))==null?'':__t)+
'" class="btn btn-default btn-phone" data-omtag="rate_table:phone" data-phone-number="'+
((__t=( rate.PhoneNo ))==null?'':__t)+
'"><i class="ra ra-phone" data-omtag="rate_table:phone"></i> '+
((__t=( rate.PhoneNo ))==null?'':__t)+
'</a>\n          ';
}
__p+='\n          ';
 if (rate.AutoDebitDisc > 0) {
__p+='\n            <div class="auto-debit-disc">\n              <div>Discount: offered if</div>\n              <div>auto debit is enabled</div>\n            </div>\n          ';
}
__p+='\n          ';
 if (rate.AnnualFee) { 
__p+='\n            <div>Annual&nbsp;Fee&colon;&nbsp;&dollar;'+
((__t=( rate.AnnualFee.toFixed(0) ))==null?'':__t)+
'</div>\n          ';
 } 
__p+='\n          ';
 if (rate.Points > 0) {
__p+='\n            <div class="points">Points&colon;&nbsp;'+
((__t=( rate.Points.toFixed(2) ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          ';
 if (minDraw) { 
__p+='\n            <div>Min&nbsp;Draw&colon;&nbsp;'+
((__t=( minDraw ))==null?'':__t)+
'</div>\n          ';
 } 
__p+='\n          ';
 if (rate.LastUpdated) {
__p+='\n            <div class="hel-last-updated">Last updated '+
((__t=( rate.LastUpdated ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n        </div>\n        <div class="col-xs-8 col-xxs-6">\n          <div class="row">\n            <div class="col-xs-6">\n              <div class="hel-loan-type">'+
((__t=( loanType ))==null?'':__t)+
'</div>\n              ';
 if (rate.IntroApr) {
__p+='\n                <div class="hel-title">Intro APR</div>\n                <div class="hel-content hel-rate">'+
((__t=( rate.IntroApr.toFixed(3) ))==null?'':__t)+
'%<span> first '+
((__t=( rate.IntroPeriod ))==null?'':__t)+
' mo</span></div>\n              ';
}
__p+='\n              ';
 if (rate.Apr) {
__p+='\n                ';
 var title = rate.IntroApr? "APR after": "APR"
__p+='\n                <div class="hel-title">'+
((__t=( title ))==null?'':__t)+
'</div>\n                <div class="hel-content hel-rate">'+
((__t=( rate.Apr.toFixed(3) ))==null?'':__t)+
'%</div>\n              ';
}
__p+='\n              ';
 if (rate.Rate && rate.LoanType === "HELOAN") {
__p+='\n                <div class="heloan-rate">Rate: '+
((__t=( rate.Rate.toFixed(3) ))==null?'':__t)+
'%</div>\n              ';
}
__p+='\n              ';
 if (rate.LoanPayment) {
__p+='\n                <div class="hel-title">Estimated payment</div>\n                <div class="hel-monthly-payment">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.LoanPayment) ))==null?'':__t)+
'<span> /mo</span></div>\n              ';
}
__p+='\n              <a class=\'link-rate-detail margin-top-lg display-block link-rate-detail-'+
((__t=( index ))==null?'':__t)+
'\' data-omtag=\'rate_table:modal_loan_details\'>Loan Details</a>\n\n              <!-- Modal -->\n              <div class=\'hel-rate-card-modal hel-rate-card-modal-'+
((__t=( index ))==null?'':__t)+
'\'>\n                <div class="hel-rate-card-modal-content">\n                  <div class=\'hel-rate-card-modal-close hel-rate-card-modal-close-'+
((__t=( index ))==null?'':__t)+
'\'>&times;</div>\n                  <p class="hel-modal-header">Loan Details</p>\n                  <div class="modal-title">Name</div>\n                  <div class="hel-modal-content">'+
((__t=(  rate.Advertiser ))==null?'':__t)+
'</div>\n                  ';
 if (rate.Summary.length) {
__p+='\n                    <div class="modal-title">Summary</div>\n                    ';
 for(var i = 0; i < rate.Summary.length; i++) {
__p+='\n                      <li class="modal-summary-list" type="disc"><span class="li-detail">'+
((__t=( rate.Summary[i] ))==null?'':__t)+
'</span></li>\n                    ';
 } 
__p+='\n                  ';
 } 
__p+='\n                  <div class="modal-title">Loan Details</div>\n\n                  <div class="hel-modal-content">Loan Type: '+
((__t=( loanType ))==null?'':__t)+
'</div>\n\n                  <div class="hel-modal-content">Loan Amount: '+
((__t=( loanAmount ))==null?'':__t)+
'</div>\n\n                  <div class="hel-modal-content">Loan Term: '+
((__t=( rate.LoanTerm ))==null?'':__t)+
'&nbsp;months</div>\n                  ';
 if (rate.IntroApr) { 
__p+='\n                    <div class="hel-modal-content">Intro APR: '+
((__t=( rate.IntroApr.toFixed(3) ))==null?'':__t)+
'&percnt;</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.IntroPeriod) { 
__p+='\n                    <div class="hel-modal-content">Intro Period: '+
((__t=( rate.IntroPeriod ))==null?'':__t)+
'&nbsp;months</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.IntroPeriod) { 
__p+='\n                    <div class="hel-modal-content">APR after: '+
((__t=( rate.Apr.toFixed(3) ))==null?'':__t)+
'&percnt;</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.AnnualFee) { 
__p+='\n                    <div class="hel-modal-content">Annual Fee: &dollar;'+
((__t=( rate.AnnualFee.toFixed(0) ))==null?'':__t)+
'</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.Fee) { 
__p+='\n                    <div class="hel-modal-content">Origination Fee: &dollar;'+
((__t=( rate.Fee.toFixed(2) ))==null?'':__t)+
'</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.MaxLTV) { 
__p+='\n                    <div class="hel-modal-content">Max LTV: '+
((__t=( rate.MaxLTV ))==null?'':__t)+
'%</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.LastUpdated) { 
__p+='\n                    <div class="hel-modal-content">Last Updated: '+
((__t=( rate.LastUpdated ))==null?'':__t)+
'</div>\n                  ';
 } 
__p+='\n                  ';
 if (rate.Summary.length) {
__p+='\n                  <div class="modal-title">Conditions:</div>\n                  <div class="hel-modal-condition">'+
((__t=( rate.Conditions.replace('Conditions… ', '') ))==null?'':__t)+
'</div>\n                  ';
 } 
__p+='\n                </div>\n\n                ';
 if (rate.CpcUrl) {
__p+='\n                  <a class="btn btn-primary hel-modal-next" href="'+
((__t=( rate.CpcUrl ))==null?'':__t)+
'" target=\'_blank\' data-omtag=\'rate_table:lender\' rel=\'nofollow\'>Next</a>\n                ';
 } 
__p+='\n                <a class="btn btn-secondary hel-modal-close">Close</a>\n                <div class="hel-rate-card-modal-backdrop"></div>\n              </div>\n              <!-- End Modal -->\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="row gutter-sm margin-top">\n        <div class="col-xxs-12">\n          ';
 if (rate.CpcUrl) {
__p+='\n            <a href="'+
((__t=( rate.CpcUrl ))==null?'':__t)+
'" class="btn btn-primary" target=\'_blank\' data-omtag=\'finance:rate_table_heloc:rate_table:lender\' rel=\'nofollow\'>Next</a>\n          ';
}
__p+='\n        </div>\n      </div>\n\n   </div>\n</div>\n<!-- End Rate Card -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/home_equity_rate_table_card_mobile.jst.ejs